// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"fe3b7f1c","453":"10ead536","455":"2eec1e07","533":"f2b80898","644":"fbe79574","937":"9c18f130"}[chunkId] + ".chunk.js";
};